<template>
  <div class="title-label noto500">
    {{title}}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  name: "TitleLabel"
}
</script>

<style scoped>
.title-label {
  transform: skewX(-10deg);
  position: absolute;
  top:10vh;
  left: -2vw;
  padding: 1vh 3vw 1vh 4vw;
  background: white;
  color: #e74a23;
  border: 4px solid #e74a23;
  font-weight: bold;
  /*background: #e74a23;*/
  z-index: 2;
  font-size: 4vh;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TitleLabel.vue